import script from "./AppointmentCancellationRequestCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./AppointmentCancellationRequestCard.vue?vue&type=script&setup=true&lang=ts"

import "./AppointmentCancellationRequestCard.vue?vue&type=style&index=0&id=5cf6c188&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5cf6c188"]])

export default __exports__